import { Router } from '@angular/router';
import { Option } from '@sapphire/result';

import { SurveyChildKey } from '../../state/survey-creation-shared-state.model';
import { ACTIVE_CHILD_KEY_STATE } from '../../state/core/utils/active-child-navigation.helper';

/**
 * The child the current navigation asked to open, passed as
 * `ACTIVE_CHILD_KEY_STATE` (see activeChildNavigationExtras). Navigation
 * state is untyped, so anything but a number or string is ignored.
 */
export function navigationActiveChildKey(
  router: Router,
): Option<SurveyChildKey> {
  return Option.from(router.currentNavigation())
    .andThen((navigation) => Option.from(navigation.extras.state))
    .andThen((state) => Option.from<unknown>(state[ACTIVE_CHILD_KEY_STATE]))
    .filter(isSurveyChildKey);
}

function isSurveyChildKey(key: unknown): key is SurveyChildKey {
  return typeof key === 'number' || typeof key === 'string';
}
